import type { CalendarLocale } from "../types/types";

export const en: CalendarLocale = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  },
  months: {
    shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  localeTag: "en",
  weekNumberHeader: "Wk",
  rangeDurationOne: "1 day",
  rangeDurationOther: "{n} days",
  inputPlaceholder: "Select date",
  rangeInputPlaceholder: "Select date range",
  rangeCancel: "Cancel",
  rangeApply: "Apply",
};
